<template>
    <section>
        <div class="mask choose-hotel" >
            <div class="e-modal medium">
                <div class="e-modal-title">Please Select the Property</div>
                <div class="e-modal-body">
                    <div class="action">
                        <p>Total <span class="color-1478e4"> {{hotelList.length}} </span> products</p>
                        <div class="search-box">
                            <!--<input type="text"  v-model="hotelName" @keyup.enter="initData">-->
                            <input type="text" v-model="hotelName" @keyup.enter="initData" placeholder="Hotel name" style="padding-left: 15px;">
                            <span class="search-btn" @click="initData">search</span>
                            <div class="action-btn" v-if="userHasPersission(3)" @click="pageTo('/order')">Reservation</div>
                            <div class="action-btn" v-if="userHasPersission(7)" @click="pageTo('/payments')">Payment statement</div>
                            <div class="action-btn" v-if="userHasPersission(20)" @click="pageTo('/veri')">Voucher Verification</div>
                        </div>
                    </div>
                    <div class="table-box-hack">
                        <table class="stripe" cellspacing="0">
                            <tr style="font-weight: 600;">
                                <td width="20%">Property ID</td>
                                <td width="40%">Property Name</td>
                                <td width="15%">City</td>
                                <td width="25%">Region</td>
                            </tr>
                            <tr v-if="!hotelList">
                                <td colspan="4" >No relevant data...</td>
                            </tr>
                            <tr v-for="item in hotelList" v-if="hotelList&&hotelList.length>0" @click="toRoomStatus(item)">
                                <td>{{item.HotelId}}</td>
                                <td>{{item.EnHotelName}}</td>
                                <td>{{item.CityName}}</td>
                                <td>{{item.DistrictName}}</td>
                            </tr>
                         
                        </table>
                      </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      hotelName: '',
      hotelList:'',
      isLoading:false,
      userInfo:JSON.parse(this.dao.get('res')),
    }
  },
  beforeCreate(){
      
    this.dao.set('activePage','/index');
  },
  methods:{
      initData () {
        var that=this;
        var params={
          name: that.hotelName
        }
        that.hotelList='';
        that.isLoading = true;
        that.getRequest({
            url: that.Api.getHotelList,
            params: params
        }).then(res => {
            that.isLoading = false;
            if (res && res.Result && res.Total > 0) {
               
                that.hotelList=res.Result;
            } else {
                that.hotelList='';
                // that.error({ title: '提示', content: '没有查询到相关数据' });
            }
        });
      },
      userHasPersission(pms){
          return this.userInfo.Permissions&&this.userInfo.Permissions.indexOf(pms)>-1?true:false;
      },
      pageTo(url){
          this.$router.push(url);
      },
      toRoomStatus(item){
       
          if(this.userHasPersission(5)){
              this.dao.set('HotelName',item.EnHotelName)
              this.dao.set('HotelId',item.HotelId)
              this.$router.push('/roomPriceAndStatus');
          }else{
              this.error({ title: 'Tips', content:'You do not have access to the hotel, please contact your main account！' });
          }
    

      }
  },

  mounted(){
      this.initData();
  }
}
</script>





// WEBPACK FOOTER //
// src/components/Index.vue